import {get} from "../api"
import * as url from "../url"

const apiGetUserNotificationsModalList = data => {
  return get(url.API_NOTIFICATIONS + "user-list/", data.history)
}

export {
  apiGetUserNotificationsModalList,
}
